module.exports = __webpack_public_path__ + "assets/img/swedbank-logo.d5d0d55c.png";